import { ProfileGender } from '@ixicare/resources';
import { t } from '~/i18n';

export const genders = [
  {
    value: ProfileGender.Male,
    label: t('global.male'),
  },
  {
    value: ProfileGender.Female,
    label: t('global.female'),
  },
];

export const teams = [
  {
    value: [],
    label: t('global.team.staff'),
    description: '',
  },
  {
    value: ['Admin HCP Team'],
    label: t('global.team.admin'),
    description: t('global.team.adminDescription'),
  },
  {
    value: ['Installer Team', 'Admin HCP Team'],
    label: t('profiles.role.installer'),
    description: t('profiles.role.installerDescription'),
  },
  {
    value: ['Installer Team', 'Admin HCP Team', 'Organization Admin Team'],
    label: t('profiles.role.organizationAdmin'),
    description: t('profiles.role.organizationAdminDescription'),
  },
];
